import React, { useEffect, useRef } from 'react';
import { Joyride, ACTIONS, STATUS } from 'react-joyride';
import { useLocation } from 'react-router-dom';
import { useHelp } from './HelpContext';
import { TOUR_STEPS } from './TourSteps';

const PageTour = () => {
  const { isTourRunning, tourKey, stopTour } = useHelp();
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  // Stop the tour whenever the user navigates to a different page.
  // This prevents a stale isTourRunning=true (e.g. after logout/login) from
  // re-triggering the tour on the landing page.
  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      prevPathnameRef.current = pathname;
      if (isTourRunning) stopTour();
    }
  }, [pathname, isTourRunning, stopTour]);

  const rawSteps = TOUR_STEPS[pathname] || [];
  const steps = rawSteps.map(s => ({ ...s, disableBeacon: true }));

  const handleCallback = ({ action, status }) => {
    if (
      [STATUS.FINISHED, STATUS.SKIPPED].includes(status) ||
      action === ACTIONS.CLOSE
    ) {
      stopTour();
    }
  };

  if (!steps.length) return null;

  return (
    <Joyride
      key={tourKey}
      steps={steps}
      run={isTourRunning}
      continuous
      showSkipButton
      showProgress
      scrollToFirstStep
      callback={handleCallback}
      locale={{
        back: 'Back',
        close: 'Close',
        last: 'Finish',
        next: 'Next',
        skip: 'Skip tour',
      }}
      styles={{
        options: {
          primaryColor: '#C9194A',
          zIndex: 10000,
          arrowColor: '#fff',
          backgroundColor: '#fff',
          textColor: '#1a1a2e',
          overlayColor: 'rgba(0, 0, 0, 0.55)',
        },
        tooltip: {
          borderRadius: '10px',
          fontFamily: "'Poppins', sans-serif",
          fontSize: '13px',
          padding: '16px',
        },
        tooltipTitle: {
          fontSize: '14px',
          fontWeight: 600,
          color: '#1a1a2e',
          marginBottom: '6px',
        },
        tooltipContent: {
          padding: '4px 0 8px',
          lineHeight: 1.5,
          color: '#444',
        },
        buttonNext: {
          background: 'linear-gradient(135deg, #C2185B 0%, #C9194A 100%)',
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: 600,
          padding: '6px 16px',
        },
        buttonBack: {
          color: '#6c757d',
          fontSize: '12px',
        },
        buttonSkip: {
          color: '#6c757d',
          fontSize: '12px',
        },
        spotlight: {
          borderRadius: '8px',
        },
      }}
    />
  );
};

export default PageTour;
